import { render } from "./ButtonBlock.vue?vue&type=template&id=07179f0a"
import script from "./ButtonBlock.vue?vue&type=script&lang=js"
export * from "./ButtonBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__